module.exports = __webpack_public_path__ + "img/unoeste.acdd8261.jpg";